import * as React from "react";
import { Modal ,Button} from "antd";
export const WelcomeModal = ({ isOpen, onClose, ...props }) => {
  return (
    <Modal
    containerStyle={{borderRadius: '0px', width:'620px'}}
    maskStyle={{ backgroundColor: "red" }} 
   
     className='welcome_modal' title="" visible={isOpen}  footer={null}  onCancel={onClose}>
      <div className='welcome_modal__content'>
      <img style={{width:'480px'}} src={"images/welcome.svg"} />
      <div style={{display:'flex', flexDirection:'column', gap:'40px', padding:'32px 24px'}}>

      <div style={{textAlign:'center',display:'flex', flexDirection:'column', gap:'8px'}}>
        <div style={{fontSize:'24px', fontWeight:'500', color:'var(--gray70)'}}>Welcome to Tigg  🎉</div>
        <div style={{fontSize:'14px', fontWeight:'400', color:'var(--gray60)'}}>
        Congratulations on taking the first step toward hassle-free accounting! We're thrilled to have you on board. Get ready for a smooth ride as we simplify your business 
in no time.
        </div>
        </div>
      
              <Button
                onClick={() => {
                  props.history.push({ pathname: `/new-company` });
                }}
                // label="Add New Organization"
                style={{
                  borderRadius: "4px",
                  background: "#07073F",
                  color: "#FFFFFF",
                  height: "38px",
                  minWidth: "100%",
                }}
              >
                Add New Organization
              </Button>
      </div>

          
      </div>
      
    </Modal>
  );
};
